import Vue from 'vue'
import Axios from 'axios'
import strings from '../strings'
import { getCookie } from '../utils/auth-utils'
import store from '../store'
import router from '../router'
import notify from '@/api/notification'

const redirectToLogin = () => {
  store.dispatch('clearAllData')
  router.push('/')
}

const isThisTheLoginUrl = url => url && url.includes('oauth/token')
const isThisUserInfoUrl = url => url && url.includes('operator')
const isThisAPublicUrl = url => url && url.includes('public')
const isThisLocalEnv = env => env.includes('localhost')
const isThisNotAnAuthenticationRequest = url =>
  !isThisTheLoginUrl(url) && !isThisAPublicUrl(url) && !isThisUserInfoUrl(url)

// Configurações HTTP Globais
Vue.prototype.$http = Axios
window.axiosref = Axios
Axios.defaults.baseURL = process.env.BACKEND_URL
Axios.defaults.headers['Content-Type'] = strings.headers.formJSON

Axios.interceptors.request.use(
  config => {
    const contentType = config.headers['Content-Type']

    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }

    if (
      !(config.data instanceof FormData) &&
      contentType &&
      contentType.toLowerCase() === 'application/x-www-form-urlencoded'
    ) {
      const params = new URLSearchParams()
      for (const key in config.data) {
        if (config.data.hasOwnProperty(key)) {
          params.append(key, config.data[key])
        }
      }
      config.data = params.toString()
    }

    if (isThisNotAnAuthenticationRequest(config.url)) {
      if (isThisLocalEnv(process.env.BACKEND_URL)) {
        config.headers['Authorization'] = strings.headers.basicAuthenticationForLocalHost

        const token = getCookie('token_aol')
        if (token) {
          config.headers['BEARER_TOKEN_HEADER'] = token
        }

        const profile = getCookie('profile')
        if (profile) {
          config.headers['OPERATOR_HEADER'] = profile.username
        }

        if (
          config.url.includes('/change/password') ||
          config.url.includes('/auth/login')
        ) {
          delete config.headers['Authorization']
        }
      } else {
        const token = getCookie('token_aol')
        if (token) {
          config.headers['Authorization'] =
            `${strings.headers.bearerAuthentication}${token}`
        }

        if (
          config.url.includes('/change/password') ||
          config.url.includes('/auth/login')
        ) {
          delete config.headers['Authorization']
        } else {
          const profile = getCookie('profile')
          if (profile) {
            config.headers['operator-header'] = profile.username
            config.headers['id-laboratory'] = profile.id_laboratory
          }
        }
      }
    } else {
      config.headers['Authorization'] = strings.headers.basicAuthentication
    }

    // Configuração para Requisições de Autorização
    if (isThisUserInfoUrl(config.url)) {
      const token = getCookie('token_aol')
      if (token) {
        config.headers['Authorization'] =
          `${strings.headers.bearerAuthentication} ${token}`
      }
    }

    if (isThisLocalEnv(process.env.BACKEND_URL)) {
      if (isThisTheLoginUrl(config.url) || isThisUserInfoUrl(config.url)) {
        config.baseURL = process.env.AUTH_URL
      }
    }

    if (config._isRetry) {
      config.headers.Authorization =
        strings.headers.bearerAuthentication + getCookie('token_aol')
      delete config._isRetry
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

Axios.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      console.error('Erro sem resposta do servidor:', error)
      return Promise.reject(error)
    }

    const { status, config, headers } = error.response
    const requestUrl = config ? config.url : ''
    const isDefaulter =
      headers &&
      headers['www-authenticate'] &&
      headers['www-authenticate'].includes('defaulter')

    const notifyUser = (title, message) => {
      notify({ title, message })
    }

    const handleSessionExpired = () => {
      if (
        error.response.config.url.includes('/oauth/refresh') ||
        error.response.config.url.includes('/auth/refresh')
      ) {
        notifyUser('AVISO:', 'Sua sessão expirou, por favor faça login novamente.')
        redirectToLogin()
        return Promise.reject(error)
      } else {
        if (error.config._isRetry) {
          error.config._isRetry = true
          store.dispatch('refreshToken')
          return Axios(error.config)
        } else {
          store.dispatch('refreshToken')
          return Promise.reject(error)
        }
      }
    }

    const handleForbiddenError = () => {
      notifyUser(
        'AVISO:',
        'Desculpe, ocorreu um erro inesperado. Por favor, tente novamente mais tarde.'
      )
    }

    const handleAccessBlocked = () => {
      notifyUser(
        'AVISO:',
        'Acesso bloqueado: Entre em contato com o time de atendimento através do 0800 643 8100 ou pelo e-mail: cobranca@dasa.movidesk.com'
      )
    }

    if (
      status === 401 &&
      requestUrl &&
      !requestUrl.includes('/oauth/token') &&
      !requestUrl.includes('/auth/login')
    ) {
      return handleSessionExpired()
    } else if (status === 403) {
      if (isDefaulter) {
        handleAccessBlocked()
      } else {
        handleForbiddenError()
      }
    }

    return Promise.reject(error)
  }
)
